import React from 'react';
import { TooltipProps } from './types';
import { HoverPopup, HoverElement } from './styles';

export const Tooltip = ({
  children,
  popup,
  position = 'top',
  hoverable = true,
  extendStyles,
}: TooltipProps) => {
  return (
    <HoverElement hoverable={hoverable} style={extendStyles?.element}>
      <HoverPopup position={position} style={extendStyles?.popup}>
        {popup}
      </HoverPopup>
      {children}
    </HoverElement>
  );
};
